module.exports = __webpack_public_path__ + "media/images/page-not-found-6933ca7d133340bf67894161c00e0878.svg";